<template>
  <table>
    <thead>
      <tr>
        <th>Channel</th>
        <th v-if="ioMode == 3">
          Manual
        </th>
        <th>Value</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ConfigureControllerAno v-for="(channel, index) in channels" :key="`${portNumber}${channelOffset + index}`"
        :ioMode="ioMode"
        :port="port"
        :portNumber="portNumber"
        :channel="channel" 
        :channelNumber="channelOffset + index"
      ></ConfigureControllerAno>
    </tbody>
  </table>
</template>

<script>
import ConfigureControllerAno from "./ChannelConfigurationAno.vue";

export default {
  components: { ConfigureControllerAno },
  props: [
    "ioMode",
    "port",
    "portNumber",
    "channelOffset",
    "sensorModels"
  ],
  computed: {
    channels() {
      return this.port.analogOutputs.children.slice(
        this.channelOffset,
        this.channelOffset + 8
      );
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
thead button {
  width: 50px;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
}
:deep(th), 
:deep(td) {  
  padding: 10px;
  text-align: left;
  border-bottom: 1px dashed #ccc;
}
</style>
